const MAX_NOTE_LENGTH = 100;


function DateStr( dt )
{
    return ( dt.toISOString( ).substr( 0, 16 ) );
}

function SetDeliveryDate( )
{
    var sel  = document.getElementById( "gift-card-date-control" );
    var dt   = sel.options[ sel.selectedIndex ].value;
    var when = document.getElementById( "giftcard-delivery-date-input" );

    if ( dt == "now" )
    {
        when.value = DateStr( new Date( ) );
        when.classList.add( "hidden" );
    }
    else if ( dt == "tomorrow" )
    {
        when.value = DateStr( new Date( new Date( ).getTime( ) + ( 24 * 60 * 60 * 1000 ) ) );
        when.classList.add( "hidden" );
    }
    else
    {
        when.classList.remove( "hidden" );
    }
}

function GiftCardNoteChanged( e )
{
    var ta   = document.querySelector( "textarea[name='properties[ message ]']" );
    var note = ta.value;
    var left = MAX_NOTE_LENGTH - note.length;
            
    if ( left < 0 )
    {
        left = 0;
        note = note.substr( 0, MAX_NOTE_LENGTH );
        ta.value = note;
    }
    
    document.querySelector( "#giftcard-message-remaining-chars" ).innerHTML = left;
}

function ShowActiveGiftCardVariant( e )
{
    $( ".product-page__form__options__amounts label.giftcard-active" ).removeClass( "giftcard-active" );
    e.currentTarget.classList.add( "giftcard-active" );
}

function StartupGiftCardPage( )
{
    console.log( "gift card page starting" );
    $( "#gift-card-date-control" ).on( "change", SetDeliveryDate );
    $( "textarea[name='properties[ message ]']" ).on( "input", GiftCardNoteChanged );
    $( ".product-page__form__options__amounts label" ).on( "click", ShowActiveGiftCardVariant );
    SetDeliveryDate( );
}

window.addEventListener( "load", StartupGiftCardPage );